@if (inputs?.length === 0 && isActiveInput()) {
  <span class="blinking">|</span>
}
@for (char of inputs; track char; let i = $index) {
  <span [tabindex]="0" (keyup.enter)="onCharClick(i)" (click)="onCharClick(i)"
    >{{ char }}
    @if (showIndicator(i)) {
      <span class="blinking">|</span>
    }
  </span>
}
